import { useMutation } from "@tanstack/react-query";
import { t } from "i18next";
import { useShallow } from "zustand/shallow";
import { loginAsNormalUser } from "../api/auth.api";
import { useUIStore } from "../stores/ui-store";
import { UIState } from "../types/ui-types";

const useLogin = () => {
  const [toast, setBearerToken] = useUIStore(
    useShallow((state: UIState) => [state.toastRef, state.setBearerToken]),
  );

  // Create new company
  const login = (email: string, password: string) => {
    loginMutation.mutate({ email, password });
  };

  const loginMutation = useMutation({
    mutationFn: (payload: { email: string; password: string }) =>
      loginAsNormalUser(payload.email, payload.password),
    onError: (error) => {
      console.error("Failed to login:", error);
      toast?.current?.show({
        severity: "error",
        detail: t("label-user-login-failed"),
        life: 3000,
      });
    },
    onSuccess: (result) => {
      setBearerToken(result.access_token);
    },
  });

  const isLoggingIn = loginMutation.isPending;

  return {
    login,
    isLoggingIn,
  };
};

export default useLogin;
